import { render, staticRenderFns } from "./easyToUse.vue?vue&type=template&id=4cc2b39a"
var script = {}
import style0 from "./easyToUse.vue?vue&type=style&index=0&id=4cc2b39a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports